import { render } from "./GlobalPdfGenerator.vue?vue&type=template&id=4f2e253e&scoped=true"
import script from "./GlobalPdfGenerator.vue?vue&type=script&lang=js"
export * from "./GlobalPdfGenerator.vue?vue&type=script&lang=js"

import "./GlobalPdfGenerator.vue?vue&type=style&index=0&id=4f2e253e&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f2e253e"]])

export default __exports__